import { useEffect, useState, useRef } from 'react';
import countries from '../data/countries.json'
import Flag from './Flag';


const CountrySelect = ({ selected, onSelect, fullWidth = false }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [search, setSearch] = useState('');
  const [filtered, setFiltered] = useState(countries);
  const dropdownRef = useRef();


  useEffect(() => {
    const results = countries.filter((c) =>
      c.name.toLowerCase().includes(search.toLowerCase())
    );
    setFiltered(results);
  }, [search]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }
  
    if (showDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
  
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDropdown]);

  return (
    <div ref={dropdownRef} className="relative z-10">
      <button
        type="button"
        onClick={() => setShowDropdown((prev) => !prev)}
        className={`flex items-center bg-white px-3 py-2 rounded-md text-left shadow-sm ${
          fullWidth ? 'w-full border border-purple-200' : 'w-fit'
        }`}
      >
        <Flag country={selected} />
        <span className="text-gray-900 ml-2">{selected.dialCode}</span>
        {fullWidth ? (<span className="text-gray-700 ml-2">{selected.name}</span>) : null}
        <span className="text-gray-500 ml-auto">▼</span>
      </button>
  
      {showDropdown && (
        <div className="absolute left-0 mt-1 max-h-64 w-64 overflow-y-auto bg-white border border-purple-200 rounded shadow-lg">
          <input
            type="text"
            className="w-full px-3 py-2 bg-white text-gray-900 border-b border-purple-100 focus:outline-none focus:ring-2 focus:ring-purple-300"
            placeholder="Search country..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          {filtered.map((country) => (
            <div
              key={country.id}
              onClick={() => {
                onSelect(country);
                setShowDropdown(false);
              }}
              className="flex items-center px-4 py-2 text-gray-900 hover:bg-purple-50 cursor-pointer"
            >
              <span className='mr-2'><Flag country={country} /></span>
              <span className="flex-1">{country.name}</span>
              <span className="text-sm text-gray-600">{country.dialCode}</span>
            </div>
          ))}
          {filtered.length === 0 && (
            <p className="text-gray-500 px-4 py-2 text-sm">No matches found.</p>
          )}
        </div>
      )}
    </div>
  );  
};

export default CountrySelect;
